module.exports = __webpack_public_path__ + "img/loader.a6178f44.gif";